import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Utility } from 'src/app/services/utility';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';
import * as _ from 'lodash';
import { IAdminNotification } from '../../../../../../common/common-interfaces/admin-notification';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'store-admin-panel',
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.scss'],
    standalone: false
})
export class StoreAdminPanelComponent {
  sku?: string;
  barcode?: string;
  result?: string;
  @ViewChild('toolsMenu', { static: false }) toolsMenu: MatMenu;
  @ViewChild('storesMenu', { static: false }) storesMenu: MatMenu;

  private paramsSubscription?: Subscription;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {
    globals.newFeatures = window.location.hash.includes('new');
  }

  async ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe(async (params: any) => {
      this.globals.loadAdminKey();
      await this.api.loadCurrentUser();
      //  this.globals.storeName = params.storeName;
      this.globals.accessCode = params.accessCode;
      this.globals.storeSettings = await this.api.store().get<any>(`/settings`);
      this.globals.accessCode = this.globals.storeSettings.accessCode;

      document.title = `${_.capitalize(this.globals.storeSettings.name)} - ACE Gateway`;

      if(this.globals.currentUser){
        this.globals.stores = await this.api.user().get<any>(`/current/stores`);
      }

    });
  }


  ngOnDestroy(): void {
    (this.paramsSubscription as Subscription).unsubscribe();
  }

}
